import { Email, Phone } from '@mui/icons-material';
import { Grid, Typography, Divider } from '@mui/material';
import { t } from 'i18next';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import { Member } from '../models/member';
import MemberAvatar from './memberAvatar';
import { MemberDetail } from './memberDetail';
import { MemberDetailBirthDate } from './memberDetailBirthDate';
import { MemberDetailGender } from './memberDetailGender';
import { MemberDetailLink } from './memberDetailLink';

type MemberDetailsPresentationProps = {
  member: Member;
};
export const MemberDetailsPresentation = (props: MemberDetailsPresentationProps) => {
  const { member } = props;

  const displayDetails = (label: string, value: string | undefined, key: string | number, fullWidth = true) => {
    return (
      value && (
        <Grid item xs={fullWidth ? 'auto' : 6} zeroMinWidth sx={{ maxWidth: fullWidth ? '100%' : '50%' }} key={key}>
          <Typography variant='body1' component='div' sx={{ fontWeight: 500 }}>
            {label.replace(/<BR>/gi, '')}
          </Typography>
          <Typography variant='body1' component='div'>
            {value}
          </Typography>
        </Grid>
      )
    );
  };

  return (
    <>
      <GridWrapper>
        <Grid item xs='auto'>
          <MemberAvatar firstName={member.firstName ?? ''} lastName={member.lastName ?? ''} />
        </Grid>
        <Grid item xs='auto'>
          <Typography variant='h6' sx={{ fontWeight: 700 }} gutterBottom>{`${member.firstName} ${member.lastName}`}</Typography>
          <MemberDetail detail={member.address} />
          <MemberDetail detail={member.addressOther} />
          <MemberDetail detail={member.coAddress} />
          <MemberDetail detail={member.postNr} />
          <MemberDetail detail={member.postAddress} />
        </Grid>
        <Grid item>
          <Typography variant='h6' gutterBottom>
            &nbsp;
          </Typography>
          <MemberDetailLink icon={<Email sx={{ mr: 1 }} />} linkPrefix='mailto:' details={[member.email || '']} />
          <MemberDetailLink icon={<Phone sx={{ mr: 1 }} />} linkPrefix='tel:' details={[member.phone || '', member.phoneOther || '']} />
          <MemberDetailBirthDate birthDate={member.birthDate} />
          <MemberDetailGender sex={member.sex} />
        </Grid>
      </GridWrapper>
      {((member.customData && member.customData?.filter((x) => !!x.value).length > 0) ||
        (member.profileData && member.profileData?.filter((x) => x.locked).length > 0)) && (
        <>
          <Divider sx={{ my: 3 }} />
          <GridWrapper>
            {member.customData?.filter((x) => !!x.value).map((item) => displayDetails(item.heading, item.value, item.key))}
            {member.profileData?.filter((x) => x.locked).map((item) => displayDetails(item.groupName, item.itemName, item.memberProfileItem_id))}
          </GridWrapper>
        </>
      )}
      {member.profileData && member.profileData?.filter((x) => !x.locked).length > 0 && (
        <>
          <Divider sx={{ my: 3 }} />
          <GridWrapper>
            {member.profileData?.filter((x) => !x.locked).map((item) => displayDetails(item.groupName, item.itemName, item.memberProfileItem_id))}
          </GridWrapper>
        </>
      )}
      {(member.comment || member.note) && (
        <>
          <Divider sx={{ my: 3 }} />
          <GridWrapper>
            {displayDetails(t('member:memberDetails.comment'), member.comment, 'comment', false)}
            {displayDetails(t('member:memberDetails.note'), member.note, 'note', false)}
          </GridWrapper>
        </>
      )}
    </>
  );
};
